import './LastMonthWidget.scss';
import useScreenSize from '../../../hooks/useScreenSize';
import {
    computeSummary,
    computeSummaryForAccounts,
} from '../../TransactionsPage/utils/mathUtils';
import {formatCurrency} from '../../../utils';
import AccountLabel from '../../../components/common/AccountLabel';

const SummaryTable = ({
                          rows,
                          title,
                          firstColumnLabel,
                          firstColumnRender,
                          isCompact,
                      }) => {
    const visibleRows = rows.filter(row => !row.isEmpty);

    if (!visibleRows.length) return null;

    return (
        <div className="last-month__table-card">
            {title && <div className="last-month__table-title">{title}</div>}

            <table className="last-month__table">
                <thead>
                <tr>
                    <th>{firstColumnLabel}</th>
                    <th>Income</th>
                    <th>Expenses</th>
                    <th>Saved</th>
                </tr>
                </thead>

                <tbody>
                {visibleRows.map(row => {
                    const saved = row.net - row.expenses;
                    const savedClass = saved >= 0 ?
                        'positive-value' :
                        'negative-value';

                    return (
                        <tr key={`${row.accountTitle ||
                        row.currency}-${row.currency}`}>
                            <td className="last-month__main-cell">
                                {firstColumnRender(row)}
                            </td>

                            <td className="last-month__value positive-value">
                                {formatCurrency(row.income, row.currency,
                                    isCompact)}
                            </td>

                            <td className="last-month__value negative-value">
                                {formatCurrency(row.expenses, row.currency,
                                    isCompact)}
                            </td>

                            <td className={`last-month__value ${savedClass}`}>
                                {saved >= 0 ? '+' : '−'}
                                {formatCurrency(Math.abs(saved), row.currency,
                                    isCompact)}
                            </td>
                        </tr>
                    );
                })}
                </tbody>
            </table>
        </div>
    );
};

const LastMonthWidget = ({movements, accounts}) => {
    const {isCompact} = useScreenSize();

    if (!movements.length) return null;

    const summary = computeSummary(movements);
    const accountSummary = computeSummaryForAccounts(movements, accounts);

    return (
        <section className="last-month dashboard__section">
            <div className="dashboard__section-title">Balance change</div>

            <div className="last-month__tables">
                <SummaryTable
                    rows={summary}
                    title="By Currency"
                    firstColumnLabel="Currency"
                    isCompact={isCompact}
                    firstColumnRender={row => (
                        <span className="last-month__currency">
                        {row.currency}
                    </span>
                    )}
                />

                <SummaryTable
                    rows={accountSummary}
                    title="By Account"
                    firstColumnLabel="Account"
                    isCompact={isCompact}
                    firstColumnRender={row => (
                        <AccountLabel account={{title: row.accountTitle, sourceName: row.accountSourceName}}/>
                    )}
                />
            </div>
        </section>
    );
};

export default LastMonthWidget;